export const LANGUAGE_LABELS = {
  html: 'HTML',
  javascript: 'JavaScript',
  js: 'JavaScript',
  jsx: 'JavaScript',
  ts: 'TypeScript',
  typescript: 'TypeScript',
  tsx: 'TypeScript',
  css: 'CSS',
  python: 'Python',
  ruby: 'Ruby',
  json: 'JSON',
  xml: 'XML',
  yaml: 'YAML',
  markdown: 'Markdown',
  sql: 'SQL',
  bash: 'Bash',
  plain: 'Plain Text',
  php: 'PHP',
  go: 'Go',
  java: 'Java',
  swift: 'Swift',
  kotlin: 'Kotlin',
};

export type Language = keyof typeof LANGUAGE_LABELS;
